import { AuditLogRoutes, BatchAdminRoutes, BrandsRoutes, HomeRoutes, MappersStatsRoutes, MatchersRoutes, PriceAnalysisRoutes, ProductsReviewRoutes, RetailerProductsRoutes, RetailerBrandsRoutes, CategoriesRoutes, ScrapingDataReviewRoutes, SessionRoutes, SkuCandidatesRoutes, SkuDuplicatesRoutes, SkuManagementRoutes, UnmatchedRoutes, UserStatsRoutes, VtAdminRoutes, VtAiCostsRoutes, VtMyTasksRoutes, VtPipelineRoutes, VtResourcesRoutes, VtResourceDetailRoutes, VtResourceMergeRoutes, VtReviewQueueRoutes, VtReviewRoutes, VtOperatorMetricsRoutes, VtMappingMetricsRoutes } from "./Pages"

// Pick a matcher route by its title (matcher routes carry their own `access`, preserved here)
const matcher = (t) => MatchersRoutes.find(r => r.title === t)
const GROUPED_MATCHER_TITLES = new Set(["SKU to Product", "Product to SKU", "SKU Mapping", "Raw to Raw"])
// Safety net: any matcher route not explicitly placed in a group below stays reachable (top-level)
const ungroupedMatchers = MatchersRoutes.filter(
	r => r.path && r.path !== "/" && !GROUPED_MATCHER_TITLES.has(r.title)
)

const routes = [
	// Home as main page
	HomeRoutes,
	...ungroupedMatchers,
	{
		// SKU world: the SKU matchers + their review/candidate/unmatched surfaces
		title: "SKU Mapping",
		icon: 'diagram-project',
		iconWeight: 'light',
		isGroup: true,
		children: [
			matcher("SKU to Product"),   // sku2raw (reverse)
			matcher("Product to SKU"),   // raw2sku (direct)
			matcher("SKU Mapping"),      // skus
			ProductsReviewRoutes,
			SkuCandidatesRoutes,
			SkuDuplicatesRoutes,
			UnmatchedRoutes,
		].filter(Boolean)
	},
	{
		// Retailer world: raw2raw matcher + retailer/competitor dashboards
		title: "Retailers",
		icon: 'store',
		iconWeight: 'light',
		isGroup: true,
		children: [
			matcher("Raw to Raw"),       // raw2raw (products matcher)
			RetailerProductsRoutes,
			RetailerBrandsRoutes,
			CategoriesRoutes,
		].filter(Boolean)
	},
	{
		// Cross-cutting: batches (all types) + audit
		title: "Operations",
		icon: 'layer-group',
		iconWeight: 'light',
		isGroup: true,
		children: [
			BatchAdminRoutes,
			AuditLogRoutes,
			ScrapingDataReviewRoutes,
		]
	},
	{
		title: "Analytics",
		icon: 'chart-line',
		iconWeight: 'light',
		isGroup: true,
		children: [
			MappersStatsRoutes,
			PriceAnalysisRoutes,
			UserStatsRoutes,
		]
	},
	{
		title: "Master Data",
		icon: 'database',
		iconWeight: 'light',
		isGroup: true,
		children: [
			BrandsRoutes,
			SkuManagementRoutes,
		]
	},
	{
		title: "Visibility Tracker",
		icon: 'camera-viewfinder',
		iconWeight: 'light',
		isGroup: true,
		children: [
			VtMyTasksRoutes,
			VtAdminRoutes,
			VtReviewRoutes,
			VtReviewQueueRoutes,
			VtPipelineRoutes,
			VtResourcesRoutes,
			VtResourceDetailRoutes,
			VtResourceMergeRoutes,
			VtAiCostsRoutes,
			VtOperatorMetricsRoutes,
			VtMappingMetricsRoutes,
		]
	},
	...SessionRoutes,
]
export default routes